import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { API } from '../context/AuthContext';
import { colors, fonts } from '../brand';
import Disclaimer from '../components/Disclaimer';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/api/auth/forgot-password`, { email });
    } catch {}
    setSent(true);
    setLoading(false);
  };

  return (
    <div style={styles.page}>
      <div style={styles.logoArea} onClick={() => navigate('/')}>
        <img src="/logo.svg" alt="Elephants Answering" style={styles.logoIcon} />
        <div>
          <div style={styles.logoText}>Elephants Answering, PBC</div>
          <div style={styles.logoSub}>Divorce Support & Refuge</div>
        </div>
      </div>

      <div style={styles.card}>
        {sent ? (
          <>
            <h2 style={styles.title}>Check your email</h2>
            <p style={styles.tagline}>If an account exists for that email, we've sent a reset link. Check your inbox — it's valid for 1 hour.</p>
            <p style={styles.link}><Link to="/login" style={styles.a}>Back to Sign In</Link></p>
          </>
        ) : (
          <>
            <h2 style={styles.title}>Forgot your password?</h2>
            <p style={styles.tagline}>Enter your email and we'll send you a reset link.</p>
            <form onSubmit={handleSubmit}>
              <input
                style={styles.input}
                type="email"
                placeholder="Email address"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
              />
              <button style={styles.button} type="submit" disabled={loading}>
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>
            <p style={styles.link}><Link to="/login" style={styles.a}>Back to Sign In</Link></p>
          </>
        )}
      </div>
      <Disclaimer />
    </div>
  );
}

const styles = {
  page: { display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', backgroundColor: colors.cream, padding: '40px 20px' },
  logoArea: { display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '40px', cursor: 'pointer' },
  logoIcon: { height: '140px', width: 'auto' },
  logoText: { fontFamily: fonts.heading, color: colors.navy, fontSize: '17px', fontWeight: '600', letterSpacing: '0.5px' },
  logoSub: { fontFamily: fonts.body, color: colors.textMedium, fontSize: '11px', letterSpacing: '0.3px', marginTop: '3px' },
  card: { backgroundColor: colors.white, border: `1px solid ${colors.peach}`, padding: '48px 40px', maxWidth: '420px', width: '100%' },
  title: { fontFamily: fonts.heading, color: colors.navy, fontSize: '24px', marginBottom: '8px', fontWeight: '600', letterSpacing: '0.3px' },
  tagline: { fontFamily: fonts.body, color: colors.textMedium, fontSize: '13px', marginBottom: '32px', fontStyle: 'italic', lineHeight: '1.7' },
  input: { display: 'block', width: '100%', padding: '12px 16px', marginBottom: '16px', border: `1px solid ${colors.peach}`, fontSize: '14px', fontFamily: fonts.body, boxSizing: 'border-box', outline: 'none', color: colors.navy, backgroundColor: colors.white, borderRadius: 0 },
  button: { display: 'block', width: '100%', padding: '14px', backgroundColor: colors.rose, color: colors.white, border: 'none', fontSize: '14px', cursor: 'pointer', fontWeight: '600', fontFamily: fonts.body, letterSpacing: '0.5px', borderRadius: 0 },
  link: { textAlign: 'center', marginTop: '24px', color: colors.textMedium, fontSize: '13px', fontFamily: fonts.body },
  a: { color: colors.rose, textDecoration: 'none', fontWeight: '600' },
};
